/* eslint-disable @typescript-eslint/no-var-requires */
import { Button, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { usePlayFlag } from './../../components/topicScroll';

import './animation028.less';
import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';

interface IAnimation028SubItem {
  img: string;
  title: string;
  content: string;
}

interface IAnimation028Item {
  text: string;
  subtitle?: string;
  subItems?: IAnimation028SubItem[];
}

interface IAnimation028Props {
  items: IAnimation028Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation028: React.FunctionComponent<IAnimation028Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);

  const [isModalOpen, setModalOpen] = useState(false);
  const [currPage, setCurrPage] = useState(0);
  const [modalItem, setModalItem] = useState<IAnimation028SubItem[]>();
  const [show, setShow] = useState(true);
  const [show1, setShow1] = useState(true);
  const [show2, setShow2] = useState(true);
  const setPage = (pagePlus: number) => {
    setCurrPage(currPage + pagePlus);
  };

  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      onCompleted && onCompleted();
    }
  };

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };

  return (
    <div ref={crrRef} className={`animation028 component ${className || ''}`}>
      {items.map((itm: IAnimation028Item, idx: number) => (
        <div key={idx} className="animation028-contaner">
          <div
            onClick={() => clickToPlay()}
            className={`animation028-item r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <img
              className="click-point"
              onClick={() => clickToPlay()}
              style={{
                display: play <= 1 ? 'block' : 'none',
              }}
              src={ImgPoint}
              alt=""
            />
            <img
              className="bg-img"
              src={require(`../../../../../assets/a028-${idx + 1}.png`).default}
              alt=""
            />
            <div className="text">
              {itm.text}
              {itm.subtitle ? (
                <div className="sub-task-text">
                  <Button
                    style={{ fontSize: '1.4rem' }}
                    type="link"
                    onClick={(e) => {
                      e.stopPropagation();
                      setModalOpen(true);
                      setModalItem(itm.subItems);
                      setShow2(false);
                    }}
                  >
                    {itm.subtitle}
                    <img
                      className="click-point1"
                      hidden={!show2}
                      src={ImgPoint}
                      alt=""
                    />
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ))}
      {modalItem && (
        <Modal
          width="80%"
          className="animation028-modal-ngo"
          title={
            <div className="animation028-modal-header">
              {modalItem[currPage]?.title}
            </div>
          }
          footer={null}
          open={isModalOpen}
          onCancel={() => setModalOpen(false)}
        >
          <div className="border">
            <img
              src={
                require(`../../../../../assets/${modalItem[currPage]?.img}`)
                  .default
              }
              alt=""
            />
          </div>
          <div
            className="content"
            dangerouslySetInnerHTML={{ __html: modalItem[currPage]?.content }}
          />
          <Button
            className={`prev-button ${currPage === 0 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 0}
            onClick={() => {
              setPage(-1);
              setShow(false);
            }}
          >
            <img className="arrow" src={ImgArrowLeft} alt="" />
            <img
              className="click-point1"
              hidden={!show}
              src={ImgPoint}
              alt=""
            />
          </Button>

          <Button
            className={`next-button ${
              currPage === modalItem.length - 1 ? 'hide' : ''
            }`}
            type="text"
            disabled={currPage === modalItem.length - 1}
            onClick={() => {
              setPage(1);
              setShow1(false);
            }}
          >
            <img className="arrow" src={ImgArrowRight} alt="" />
            <img
              className="click-point2"
              hidden={!show1}
              src={ImgPoint}
              alt=""
            />
          </Button>
        </Modal>
      )}
    </div>
  );
};

export default Animation028;
